import React from "react"

// Our global theme context with default values
export const ThemeContext = React.createContext({
  themeMode: "dark",
  setThemeMode: () => {},
})

// Theme provider component with state
const ThemeProvider = props => {
  const [themeMode, setThemeMode] = React.useState(() => {
    // Lazy initializer: runs once on mount. During SSR window is undefined so
    // we return a safe default — the inline script in html.js will have already
    // set the correct class on <body> before React hydrates, so there is no flash.
    if (typeof window === `undefined`) return `dark`
    // window.__theme is set synchronously by the inline script before React loads.
    if (window.__theme) return window.__theme
    const saved = localStorage.getItem(`theme`)
    if (saved) return saved
    return window.matchMedia(`(prefers-color-scheme: dark)`).matches ? `dark` : `light`
  })
  const value = { themeMode, setThemeMode }

  return (
    <ThemeContext.Provider value={value}>
      {props.children}
    </ThemeContext.Provider>
  )
}

const wrapper = ({ element }) => <ThemeProvider>{element}</ThemeProvider>

// Exports a ThemeProvider wrapper
export default wrapper
